import { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Markdown from "react-markdown";
import { fetchSharedConversation } from "modules/chat/services/chatService";
import { ConversationType } from "../chat.type";
import { AuthContext } from "core/contexts/auth/auth";
import PageNotFound from "core/components/routing/pages/pageNotFound/pageNotFound";
import {
  ChatBody,
  ChatContainer,
  ChatBodyInnerContainer,
  MessagesContentContainer,
} from "../chat.styled";
import { Messages } from "../messages";
import { useAppSelector } from "core/store/reduxStore";

// interface Message {
//   _id: string;
//   role: "user" | "assistant";
//   chatid: string;
//   model: string;
//   content: string;
//   createdAt: string;
//   updatedAt: string;
// }

// interface Conversation {
//   _id: string;
//   messages: Message[];
//   user: string;
//   model: string;
//   conversationId: string;
//   shared: boolean;
//   share_uuid?: string;
//   createdAt: string;
//   updatedAt: string;
//   conversationTitle?: string;
// }

const SharedConversation = () => {
  const { share_uuid } = useParams();
  const [conversation, setConversation] = useState<ConversationType | null>(
    null
  );
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<null | string>(null);
  const { checkAuthToken, amsUser } = useContext(AuthContext);
  const headerState = useAppSelector((state) => state.header);
  const [selectedPreviewContent, setSelectedPreviewContent] = useState(null);
  

  useEffect(() => {
    const fetchConversation = async () => {
      try {
        const token = await checkAuthToken();

        const conversations = await fetchSharedConversation(token, share_uuid);

        if (conversations && conversations.length > 0) {
          setConversation(conversations[0]);
        } else {
          setError("Conversation not found or no longer shared.");
        }
      } catch (err) {
        setError("Failed to load conversation.");
      } finally {
        setLoading(false);
      }
    };

    fetchConversation();
  }, [share_uuid]);

  // if (loading) return <p className="text-white text-center">Loading...</p>;
  if (error) return <PageNotFound />;

  return (
    <ChatContainer className="d-flex flex-column align-items-normal" headerheight={""}>
      <ChatBody
        ismenuopen={"false"}
        className="bg-gray-200/10 shadow-lg transition-all duration-300 ease-in-out d-flex justify-content-center pt-6 w-100"
      >
        <ChatBodyInnerContainer className="chat-content mt-6">
          {conversation &&
            <MessagesContentContainer className="d-flex justify-content-center">
              <Messages amsUser={amsUser} conversation={conversation} containerWidthClasses={"screen-adjustable-width"}/>
            </MessagesContentContainer>
          }
        </ChatBodyInnerContainer>
      </ChatBody>
    </ChatContainer>
  );
};

export default SharedConversation;
